export default {
  arriveForWorkOptions: {
    0: '随时到岗',
    1: '一周内到岗',
    2: '两周内到岗',
    3: '月内到岗',
  },
  applicantStatusOptions: {
    0: '离职',
    1: '在职',
  },
}
